<template>
  <div style="margin: 3px auto;width: 400px;padding-top: 30px">
    <el-form @submit.native.prevent>
      <el-form-item label="用户名" prop="name">
        <el-input v-model="name" autofocus="true" @keydown.native.13="submit" />
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="submit()">登录</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>

import API from '../API';

export default {
  data () {
    return {
      name: '',
      password: ''
    };
  },
  methods: {
    submit () {
      API.backdoor(this.name).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.$notify({
            title: '登录成功',
            type: 'success'
          });
          this.$router.push({ path: '/' });
        }
      }).catch(() => {
        console.log('error submit!!');
      });
    }
  }
};
</script>
